var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonuses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.12 151.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.47,13.27s1.53,10-26.1,25.66c0,0-3.37-17.55,3.48-23.45s9.84-12,12.42-10.84S70.85,7.93,72.47,13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.46,39.12S38.43-4.69,57.66.41c14.4,3.82,14.81,12.86,14.81,12.86s-2.82-9.08-10.62-1.71c-5.93,5.58-13,19.42-15.48,27.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.1,52.17S13,58.51,40.37,42.39c0,0-13.52-11.69-22-8.71S3,36.22,2.72,39,1.28,48.09,5.1,52.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.49,40.84S6.57,13.71,1.37,32.91C-2.53,47.29,5.1,52.17,5.1,52.17s-6.45-7,3.82-10.06c7.8-2.33,23.31-1.51,31.45.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.2,44c1.43,2.47,5.3,2.9,8.66,1s4.92-5.51,3.5-8-5.3-2.9-8.66-1S35.78,41.55,37.2,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.2,44c-1.42-2.47.15-6,3.5-8L45.86,45C42.5,46.92,38.63,46.49,37.2,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.21,79.62h97.57a2.07,2.07,0,0,1,2.07,2.07v68.13a2.08,2.08,0,0,1-2.08,2.08H9.21a2.08,2.08,0,0,1-2.08-2.08V81.69A2.07,2.07,0,0,1,9.21,79.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.28,67.73A2.08,2.08,0,0,1,1,64.9l84.5-48.78a2.07,2.07,0,0,1,2.83.76L94.18,27a2.08,2.08,0,0,1-.76,2.83L8.93,78.58a2.07,2.07,0,0,1-2.83-.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.68,
    y: 41.21,
    width: 7.02,
    height: 15.79,
    transform: "translate(-18.63 28.67) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.76,
    y: 37.7,
    width: 7.03,
    height: 15.79,
    transform: "translate(-16.06 31.25) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.96,
    y: 79.62,
    width: 14.05,
    height: 72.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.99,
    y: 79.62,
    width: 7.03,
    height: 72.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "66.29 58.34 63.55 60.18 60.49 58.96 61.38 62.13 59.28 64.67 62.57 64.79 64.33 67.58 65.47 64.49 68.66 63.67 66.08 61.64 66.29 58.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.68 44.71 144.03 45.82 142.18 45.08 142.72 47 141.45 48.53 143.44 48.61 144.5 50.29 145.19 48.42 147.12 47.93 145.56 46.7 145.68 44.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.53 42.46 122.67 43.7 120.59 42.88 121.2 45.02 119.78 46.74 122.01 46.83 123.2 48.72 123.98 46.62 126.14 46.07 124.39 44.69 124.53 42.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.48,12.52a1.6,1.6,0,0,0-.78,2.11,1.59,1.59,0,1,0,.78-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.3,59.29a1.58,1.58,0,1,0,2.1.78A1.58,1.58,0,0,0,122.3,59.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.22,56.16a2.41,2.41,0,1,0,2,4.38,2.41,2.41,0,1,0-2-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.46,68.21a1.06,1.06,0,1,1-.52,1.41A1.07,1.07,0,0,1,53.46,68.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112,28.6a1.06,1.06,0,1,1-.51,1.41A1.06,1.06,0,0,1,112,28.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.9,25.35a1.06,1.06,0,1,1-.52,1.41A1.07,1.07,0,0,1,144.9,25.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.1,44.21a1.53,1.53,0,1,0,2,.75A1.53,1.53,0,0,0,78.1,44.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.06,71.3a1.53,1.53,0,1,0,2,.75A1.54,1.54,0,0,0,82.06,71.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.07,45.93a1.73,1.73,0,1,0,2.3.85A1.73,1.73,0,0,0,89.07,45.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.86 41.72 103.38 45.58 99.35 46.55 102.57 49.16 102.25 53.28 105.73 51.02 109.55 52.6 108.48 48.61 111.16 45.45 107.02 45.24 104.86 41.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "93.14 67.28 92.3 69.6 89.91 70.22 91.85 71.73 91.7 74.2 93.75 72.82 96.04 73.72 95.36 71.35 96.92 69.45 94.47 69.36 93.14 67.28"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonuses);
export default __webpack_public_path__ + "static/media/bonuses.ede7a003e18df2ec85f1c97671d43fa0.svg";
export { ForwardRef as ReactComponent };